module.exports = __webpack_public_path__ + "img/20190914130113360截图20190914124704243.a96bbdc6.jpg";